<template>
  <eb-panel class="rule-digital-edit-type-item" v-bind:class="{ panelHide: !isExpand }">
    <eb-panel-header slot="header">
      <span slot="title">
        <span class="rule-type-item-title">
          {{ ruleTypeItemIndex +1 }} {{ruleTypeItem.ruleType}}
        </span>
        <span class="rule-type-item-btn-area">
          <i class="el-icon-edit-outline" @click="showEditRuleTypeDialog(ruleTypeItem.templateId, ruleTypeItem.ruleType)"></i>
          <i class="el-icon-delete" @click="delRuleType(ruleTypeItem.templateId, ruleTypeItem.ruleType)"></i>
          <!-- <i class="el-icon-sort"></i> -->
        </span>
      </span>
      <template slot="button">
        <EbBtnExpand :isExpand.sync="isExpand" />
      </template>
    </eb-panel-header>
    <div class="rule-type-item-body" slot="body">
      <RuleDigitalEditListDigitalItem v-for="(item, $index) in ruleTypeItem.ruleItem" :key="$index" :ruleDigitalItem="item" :ruleDigitalItemIndex="$index"
        :ruleTypeItemIndex="ruleTypeItemIndex" />
      <div class="rule-type-item-footer">
        <i class="el-icon-edit" @click="showAddDigitalDialog"></i>
        <span @click="showAddDigitalDialog(ruleTypeItem.templateId, ruleTypeItem.ruleType, ruleTypeItem.groupSort)">&nbsp;新增规则</span>
        &nbsp;
        <i class="el-icon-edit-outline" @click="showAddRuleTypeDialog"></i>
        <span @click="showAddRuleTypeDialog(ruleTypeItem.templateId)">&nbsp;新增分组</span>
      </div>

    </div>
  </eb-panel>
</template>

<script>
import EventBus from '@/plugins/event-bus';
import EbPanel from '@/components/common/panel/eb-panel';
import EbPanelHeader from '@/components/common/panel/eb-panel-header';
import EbBtnExpand from '@/components/common/eb-btn-expand';
import RuleDigitalEditListDigitalItem from './RuleDigitalEditListDigitalItem';
import { delRuleType } from '@/services/rule/rule-digital-service';

export default {
  inject: ['showAddRuleTypeDialog', 'showEditRuleTypeDialog', 'showAddDigitalDialog'],
  components: {
    EbPanel,
    EbPanelHeader,
    EbBtnExpand,
    RuleDigitalEditListDigitalItem
  },
  props: {
    ruleTypeItem: {
      type: Object,
      required: true
    },
    ruleTypeItemIndex: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      isExpand: true
    };
  },
  methods: {
    async delRuleType(templateId, typeName) {
      this.$ebConfirm('确认要删除分组吗?')
        .then(async () => {
          try {
            let params = {
              templateId: templateId,
              typeName: typeName
            };
            let { data } = await delRuleType(params);
            if (data.returnCode === '01') {
              this.$message.success('删除分组成功！');
              EventBus.$emit('reloadRuleDigitalList');
            } else if (data.returnCode === '03') {
              this.$message.error('缺少参数');
            } else {
              this.$message.error('删除规则分组失败');
            }
          } catch (error) {
            this.$message.error(error.message);
          }
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="less">
.rule-digital-edit-type-item {
  .rule-type-item-title {
    padding-right: 5em;
  }
  .rule-type-item-btn-area {
    color: black;
    font-size: 1.2em;
    i {
      font-weight: bold;
      cursor: pointer;
    }
  }
  .rule-type-item-body {
    .rule-type-item-footer {
      margin-top: 25px;
      font-size: 20px;
      i {
        font-weight: bold;
        cursor: pointer;
      }
      span {
        cursor: pointer;
      }
    }
  }
}
</style>
